// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
console.error = () => { }


import App from './App';
import ExTableColumn from 'ex-table-column';
Vue.component(ExTableColumn.name, ExTableColumn);
// 状态管理
import store from './vuex/index';
store.dispatch("initLoginCache");//刷新时更新vuex的登录状态
import Router from './router';
// 路由拦截器
Router.beforeEach((to, from, next) => {
    if (to.matched.length != 0) {
        // console.log("是否为登录状态", store.getters.getIsLogin, to.matched, to);
        if (to.meta.requireAuth) { // 判断该路由是否需要登录权限
            if (store.getters.getIsLogin) {
                next();
            } else {
                next({
                    path: '/login',
                    query: { redirect: to.fullPath },
                })
            }
        } else {
            next();
        }
    } else {
        next({
            path: '/404',
            query: { redirect: to.fullPath }

        })
    }
})

import './assets/icon/iconfont.css'
import api from "./api/index";
import * as $cache from "./utils/cache";
import utils from "./utils";
// import echarts from 'echarts'
import eventBus from './utils/eventBus';
import msg from './utils/msg';
//自定义指令
import directive_permission from "@/directives/permission.js";
import directive_drag from "@/directives/drag.js";
import directive_formEnter from "@/directives/formEnter.js";
import directive_magnifyingGlass from "@/directives/magnifyingGlass.js";
//富文本
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'
Vue.use(mavonEditor);

//自定义filter
import "@/filters/index";
ElementUI.Dialog.props.closeOnClickModal.default = false;//el-dialog点击蒙层不许关闭弹框
const _vuePro = Vue.prototype;
_vuePro.$api = api;
_vuePro.$store = store;
_vuePro.$utils = utils;
_vuePro.$msg = msg;
_vuePro.$bus = eventBus;
_vuePro.$cache = $cache;
// _vuePro.$echarts = echarts

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.directive("permission", directive_permission);
Vue.directive("drag", directive_drag);
Vue.directive('formEnter', directive_formEnter);
Vue.directive('magnifyingGlass', directive_magnifyingGlass);

// 过滤器
import * as custom from './utils/cache'

Object.keys(custom).forEach(key => {
    Vue.filter(key, custom[key])
})





// store.dispatch("initCacheByReload");//更新仓库无状态数据

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router: Router,
    store, //使用store vuex状态管理
    components: { App },
    template: '<App/>',
})


// WEBPACK FOOTER //
// ./src/main.js